'use strict';

import CountDown from './components/CountDown.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('count-down', CountDown);

    }
}